import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { TosAndPrivacyFinePrint } from 'Components/FinePrint';
import { required } from 'Utils/FormValidation';
import { CancelButton, SubmitButton } from 'Components/Fields/Buttons';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import './CreateAccountForm.css';
import './UpdateAccountForm.css';

const UpdateAccountForm = ({ handleCancelClick, onFormSubmit, submitButtonText, initialValues }) => {
  const formName = 'updateAccountForm';
  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
    initialValues,
  });

  return (
    <div className="updateAccountFormContainer">
      <form onSubmit={(event) => handleSubmit(event)}>
        <section className="formInput">
          <div className="flexSplit2">
            <FormField
              name="firstName"
              label="First Name"
              component="InputField"
              validate={[required]}
              autoComplete="given-name"
              {...formFieldProps}
            />
            <FormField
              name="lastName"
              label="Last Name"
              component="InputField"
              validate={[required]}
              autoComplete="family-name"
              {...formFieldProps}
            />
          </div>
          <SubmitError error={formError} formName={formName} />
          <SubmitButton text={submitButtonText} submitting={submitting} mockDisabled={submitDisabled} />
          {handleCancelClick && <CancelButton text="Cancel" onClick={handleCancelClick} />}
        </section>
      </form>
    </div>
  );
};

export default UpdateAccountForm;
